import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"

export const MapMarkerAlt = (props) => {
  return <FontAwesomeIcon faIcon={faMapMarkerAlt} {...props} />
}
